
  import { mapState } from 'vuex'
  import playGames from '~/mixins/common/play-games'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  import gameMenu from '~/mixins/common/pages/game-menu'
  import cms from '~/mixins/common/cms'

  export default {
    name: 'Theme3MenuBar',
    mixins: [playGames, vipSettings, gameMenu, cms],
    data: () => ({
      expandSubMenu: null,
      selectedMenuItems: null,
      hoveredGameIndex: null
    }),
    computed: {
      ...mapState({
        menubars: state => state.cms.menus.menus,
        missionSettings: state => state.activities['mission-reward'].missionsSettings,
        missionBadge: state => state.activities['mission-reward'].missionBadge
      }),
      visibleMenuItems() {
        return this.getVisibleItems(this.menubars)
      }
    },
    methods: {
      selectMenu(menu, toggle) {
        this.selectedMenuItems = menu
        toggle()
      },
      closeMenu() {
        this.expandSubMenu = null
        this.selectedMenuItems = null
      }
    }
  }
